import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Store";
import styles from './dialog.module.scss';
import { setEnteredResetMailAddress } from "../Slice/AuthSlice";
import {
    setDialogMailRegisteredVisible,
    setDialogPasswordResetMailVisible,
    setDialogPasswordResetVisible,
    setLoginVisible
} from "../Slice/DialogSlice";
import { useRequestPasswordResetMailMutation } from "../api/ProfileAPI";
import { useRequestNewPasswordMailMutation, useResetPasswordMutation } from "../api/LoginAPI";


export default function AuthDialogPasswordReset() {

    const passwordResetVisible = useSelector((state: RootState) => state.authReducer.dialog.passwordResetVisible);
    const enteredResetMailAddress = useSelector((state: RootState) => state.authReducer.auth.enteredResetMailAddress);
    //const [createAccount, { data: createUid, isSuccess: isCreateSuccess, isError: isCreateError }] = useCreateAccountMutation();
    const [api1] = useRequestPasswordResetMailMutation();

    const [ resetPassword, {isSuccess, isError} ] = useResetPasswordMutation();
    const [ requestNewPasswordMail ] = useRequestNewPasswordMailMutation()
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();

    const headerElement = (
        <>
            <div style={{textAlign: "center"}}>
                <h3>{t('deTranslation.dialogPasswordReset.title')}</h3>
            </div>
            <p>
                {t('deTranslation.dialogPasswordReset.description')}
            </p>
        </>
    );

    const footerContent = (
        <div>
            <Button
                label={t('deTranslation.dialogPasswordReset.button1Text')}
                disabled={enteredResetMailAddress === ''}
                onClick={() => {
                    api1(enteredResetMailAddress!)
                    .unwrap()
                    .then(() => {
                        dispatch(setEnteredResetMailAddress(enteredResetMailAddress!));
                        dispatch(setDialogPasswordResetVisible(false));
                        dispatch(setDialogPasswordResetMailVisible(true));
                    }).catch(error => 'Es ist ein Fehler aufgetreten');
                }} />

            <div style={{textAlign: "left"}}>
                <p>
                    { t('deTranslation.dialogPasswordReset.backDescription') }
                </p>
                <Button
                label={ t('deTranslation.dialogPasswordReset.backButtonText') }
                onClick={() => {
                    dispatch(setDialogPasswordResetVisible(false));
                    dispatch(setDialogMailRegisteredVisible(false));
                    dispatch(setLoginVisible(true));
                }} />
            </div>
        </div>
    );

    return (
        <Dialog
            header={headerElement}
            footer={footerContent}
            visible={passwordResetVisible}
            style={{ width: '50em' }}
            onHide={() => dispatch(setDialogPasswordResetVisible(false))}
        >
            <label>{ t('deTranslation.dialogPasswordReset.inputEmailText') }</label>
            <InputText
                className={classNames(styles.areaSearchInput, 'p-inputtext')}
                id='input-mailaddress-pwreset'
                type='email'
                pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
                required
                value={enteredResetMailAddress}
                placeholder={''}
                onChange={(event) => {
                    dispatch(setEnteredResetMailAddress(event.target.value));
                }}
            />

        </Dialog>
    )
}